export enum CompetitorType {
    Default,
    Store,
    SaleChannel
}
